import { Star } from "lucide-react";

// Star rating (1-5). Renders nothing when value is falsy.
export function StarRating({ value, size = 12 }) {
  if (!value) return null;
  return (
    <span className="inline-flex items-center gap-0.5" title={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          className={n <= value ? "fill-[#c8aa6e] text-[#c8aa6e]" : "text-[#3f3f46]"}
          style={{ width: size, height: size }}
          strokeWidth={1.5}
        />
      ))}
    </span>
  );
}

function fmtWhen(c) {
  if (c.date_raw) return c.date_raw;
  if (c.date_iso) {
    try {
      return new Date(c.date_iso).toLocaleDateString("pt-PT", {
        day: "2-digit", month: "short", year: "numeric",
      });
    } catch (e) { /* noop */ }
  }
  return "";
}

// A single review captured from a source site.
export function ReviewCard({ c, showSource = false }) {
  return (
    <div className="bg-[#09090b] border border-[#27272a] px-3 py-2.5">
      <div className="flex items-center justify-between gap-2 mb-1">
        <StarRating value={c.rating} />
        <span className="text-[11px] text-[#71717a] font-mono ml-auto">{fmtWhen(c)}</span>
      </div>
      <p className="text-[13px] text-[#d4d4d8] leading-relaxed whitespace-pre-line break-words">{c.text}</p>
      {showSource && c.source_name && (
        <div className="mt-1.5 text-[11px] text-[#71717a]">via {c.source_name}</div>
      )}
    </div>
  );
}

// A list of reviews with an empty state.
export function ReviewsList({ items, showSource = false, empty = "Sem comentários recolhidos." }) {
  if (!items || items.length === 0) {
    return <div className="text-xs text-[#71717a] py-2">{empty}</div>;
  }
  return (
    <div className="space-y-2">
      {items.map((c, i) => (
        <ReviewCard key={`${c.date_iso || c.date_raw || ""}-${(c.text || "").slice(0, 24)}-${i}`} c={c} showSource={showSource} />
      ))}
    </div>
  );
}
